/**
 * Shared flow configuration for BioTemplatePremium routes.
 * Keep production and test routes in sync from one source.
 */

import { buildStripeSuccessReturnRelative, getPostPaymentSuccessPath } from "@/lib/muchasGraciasSuccessUrl";

export type PremiumCurrency = "ARS" | "USD";

export const PREMIUM_INVITE_FLOW_NAME = "premium_invite";
export const PREMIUM_WEBSITE_FLOW_NAME = "premium_website";

/** MercadoPago (ARS): misma página de éxito que Stripe; MP agrega preapproval_id/payment_id automáticamente. */
const SUCCESS_ARS = `${getPostPaymentSuccessPath()}?provider=mercadopago`;
/** Stripe (USD): misma página post-pago que Bio Premium Simple (`VITE_MUCHAS_GRACIAS_SUCCESS_PATH`). */
const SUCCESS_STRIPE = buildStripeSuccessReturnRelative();

export function getPremiumInvitePaths(currency: PremiumCurrency): {
  successPath: string;
  cancelPath?: string;
} {
  return {
    successPath: currency === "ARS" ? SUCCESS_ARS : SUCCESS_STRIPE,
    // Matches Index production route behavior.
    cancelPath: currency !== "ARS" ? "/" : undefined,
  };
}

export function getPremiumWebsitePaths(currency: PremiumCurrency): {
  successPath: string;
  cancelPath?: string;
} {
  return {
    successPath: currency === "ARS" ? SUCCESS_ARS : SUCCESS_STRIPE,
    cancelPath: currency !== "ARS" ? "/invitacion-premium" : undefined,
  };
}
